import * as React from "react";
const SvgFiRrChartPie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chart-pie_svg__a)">
      <path
        fill="#062147"
        d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m9.573 9.12-8.908 1.732a5 5 0 0 1-.368-.679l-3.34-7.7A9.987 9.987 0 0 1 21.573 9.12M12 22A9.995 9.995 0 0 1 7.124 3.278l3.338 7.691a7 7 0 0 0 2.167 2.772l6.653 5.092A9.97 9.97 0 0 1 12 22m8.5-4.755-6.125-4.688 7.581-1.473c.027.3.046.607.046.916a9.93 9.93 0 0 1-1.502 5.245"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chart-pie_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChartPie;
